import { P2GGrid, SvgLink, P2GText } from '@parcel2go/core-ui';
import CdnIconProxy from './CdnIconProxy';

interface props {
  children: string;
}

export default function InstructionsFooter(props: props) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2} alignItems="center">
      <P2GGrid item flexShrink={1}>
        <CdnIconProxy size="sm">
          <SvgLink />
        </CdnIconProxy>
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        <P2GText component="p" variant="body2">
          {props.children}
        </P2GText>
      </P2GGrid>
    </P2GGrid>
  );
}
